import { Typography } from "@material-ui/core";

export default function RestrictedPage() {
  return (
    <Typography
      style={{
        textAlign: "center",
        fontSize: 18,
        fontFamily: "Sofia",
        fontWeight: 600,
      }}
    >
      You do not have access to view this page.
    </Typography>
  );
}
